const equipmentProfile = {
  area: "Área",
  backbtn: "Atrás",
  chooseADateRange: "Escoge un rango de fechas",
  comment: "Comentario",
  createdBy: "Creado Por",
  customer: "Cliente",
  dateCreated: "Fecha de Creación",
  deleteEquipment: "Eliminar equipo",
  equipment: "Equipo",
  equipmentStatus: "Condición mecánica del equipo",
  equipmentTag: "TAG del Equipo",
  equipmentType: "Tipo de Equipo",
  goBack: "Atrás",
  hazardous: "Clasificación de area peligrosa",
  manufacturer: "Fabricante",
  mechanical: "Código de Sello Mecanico",
  model: "Modelo",
  nocomment: "Ninguno",
  product: "Producto",
  pumpHousing: "Carcasa de la bomba",
  responsible: "Selecciona responsable del equipo",
  sealTypes: "Tipo de sello mecánico",
  snackText: "Su archivo ha sido descargado en la carpeta de descargas",
  typeContract: "Tipo de Contrato",
  updatebtn: "ACTUALIZAR EQUIPO"
};
export default equipmentProfile;
